import React, { useEffect, useState } from "react";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import Input from "../../components/input";
import FIlterSelect from "../../components/filter-select";
import {
  capitalizeFirstLetter,
  getStatusColor,
  getStatusTextColor,
} from "../../utilz/function";

interface Variant {
  name: string;
  price: string;
  quantity: string;
  reorderLevel: string;
}

interface ProductData {
  _id: string;
  inventoryId: string;
  name: string;
  description: string;
  price: number;
  category: string;
  measurementUnit: string;
  quantity: string;
  reorderLevel: string;
  approvalStatus: string;
  isVariant: boolean;
  variants?: Variant[];
}

interface UserTableProps {
  data: ProductData[];
  selectedStatus?: string;
  handleStatusChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const InventoryTable: React.FC<UserTableProps> = ({ data, selectedStatus }) => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState<ProductData[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const columns = [
    { header: "SKU", accessor: "inventoryId" },
    { header: "Name", accessor: "name" },
    { header: "Category", accessor: "category" },
    { header: "Price", accessor: "price" },
    // { header: "Stock Level", accessor: "N/A" },
    { header: "Status", accessor: "approvalStatus" },
    { header: "Actions", accessor: "_id" },
  ];

  const handleUserClick = (_id: string) => {
    navigate(`/dashboard/inventory/${_id}`);
  };

  useEffect(() => {
    const filtered = data?.filter((product) => {
      const statusMatch =
        !selectedStatus || product?.approvalStatus === selectedStatus;

      const searchMatch =
        !searchQuery ||
        product?.name?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
        product?.category?.toLowerCase().includes(searchQuery?.toLowerCase());
      const productMatch =
        !selectedType || product?.approvalStatus === selectedType;

      return statusMatch && searchMatch && productMatch;
    });
    setFilteredData(filtered);
  }, [data, selectedStatus, searchQuery, selectedType]);

  const combinedData = filteredData?.map((product) => {
    const priceDisplay = product.isVariant
      ? "Variants"
      : product?.price || "N/A";
  
    return {
      ...product,
      name: (
        <div>
          <div>{capitalizeFirstLetter(product?.name)}</div>
        </div>
      ),
      category: (
        <div>
          <div>{capitalizeFirstLetter(product?.category)}</div>
        </div>
      ),
      approvalStatus: (
        <div>
          <span
            className="font-normal rounded-full p-2"
            style={{
              backgroundColor: getStatusColor(product?.approvalStatus),
              color: getStatusTextColor(product?.approvalStatus),
            }}
          >
            {capitalizeFirstLetter(product?.approvalStatus)}
          </span>
        </div>
      ),
      price: priceDisplay,
    };
  });
  

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleCustomerFilterChange = (selectedValue: string) => {
    setSelectedType(selectedValue);
  };

  return (
    <div className="py-3 bg-white rounded-3xl shadow border border-[#C9C9C9] mt-10 pt-5">
      <div className="md:flex justify-between px-5">
        <p className="text-[20px] font-bold">Inventory Status</p>
        <div className="md:flex gap-2 items-center md:mt-0 mt-2">
          <Input
            name="search"
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full"
            placeholder="Search"
            icon="searchIcon"
          />

          <FIlterSelect
            name="category"
            options={[
              { value: "premium", label: "Premium" },
              { value: "gold", label: "Gold" },
            ]}
            className="mt-2 md:-mt-2 w-full md:w-[50%]"
            icon="filterIcon"
            onChange={handleCustomerFilterChange}
            value={selectedType}
          />
        </div>
      </div>

      {combinedData?.length > 0 ? (
        <Table
          columns={columns}
          data={combinedData}
          selectedUserId={null}
          onUserClick={handleUserClick}
        />
      ) : (
        <div className="opacity-80 mt-10 font-bold text-center mx-auto">
          No Product found
        </div>
      )}
    </div>
  );
};

export default InventoryTable;
